// extracted by mini-css-extract-plugin
export var navBack = "portfolio-detail-module--navBack--kZtwA";
export var navClose = "portfolio-detail-module--navClose--ocs3s";
export var navForward = "portfolio-detail-module--navForward--GV6vf";
export var portfolioDetail = "portfolio-detail-module--portfolioDetail--6ZCZC";
export var portfolioImage = "portfolio-detail-module--portfolioImage--MyybF";
export var portfolioNav = "portfolio-detail-module--portfolioNav--CmtoM";
export var portfolioScreen = "portfolio-detail-module--portfolioScreen--hK2Xb";